import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IFormElementBaseConfig } from '../../_shared/models/form/form-element-base.model';
import { FormElementBase } from '../_directives/form-element-base.directive';
import { ReactiveFormsModule } from '@angular/forms';


@Component({
    selector: 'sirius-form-hidden',
    templateUrl: './form-hidden.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ReactiveFormsModule]
})
export class FormHiddenComponent extends FormElementBase implements OnInit {
    config?: IFormElementBaseConfig;

    ngOnInit(): void {
        if (this.config) {
            this.name = this.config.name;
            this.label = this.config.label;
            this.formFieldDependencies = this.config.dependentFormFieldComponents;
            this.validation = this.config.validation;
            this.form = this.config.form;
            this.identifier = this.config.identifier ?? '';
        }
    }
}
